export default function getFocalPointStyles(
    focalPoint:
        | "topLeft"
        | "topCenter"
        | "topRight"
        | "centerLeft"
        | "center"
        | "centerRight"
        | "bottomLeft"
        | "bottomCenter"
        | "bottomRight",
) {
    let focalPointStyles;
    switch (focalPoint) {
        case "topLeft":
            focalPointStyles = "background-position: left top;";
            break;
        case "topCenter":
            focalPointStyles = "background-position: center top;";
            break;
        case "topRight":
            focalPointStyles = "background-position: right top;";
            break;
        case "centerLeft":
            focalPointStyles = "background-position: left center;";
            break;
        case "center":
            focalPointStyles = "background-position: center center;";
            break;
        case "centerRight":
            focalPointStyles = "background-position: right center;";
            break;
        case "bottomLeft":
            focalPointStyles = "background-position: left bottom;";
            break;
        case "bottomCenter":
            focalPointStyles = "background-position: center bottom;";
            break;
        case "bottomRight":
            focalPointStyles = "background-position: right bottom;";
            break;
    }

    return focalPointStyles;
}
